import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { observer } from "mobx-react-lite";
import { ReactElement, useEffect, useState } from "react";
import { useConditionallyClosable } from "../hooks/useClosable";
import { ClosableOrder } from "../store/ClosableStore";
import styles from './Dropdown.module.css';

function Dropdown({ icon, title, children, hasNotification, className, isAutoCloseDisabled, ...props }: IDropdownProps) {
    const [isOpen, setIsOpen] = useState(props.isOpen);

    const open = () => props.setIsOpen ? props.setIsOpen(true) : setIsOpen(true);
    const close = () => props.setIsOpen ? props.setIsOpen(false) : setIsOpen(false);
    useConditionallyClosable(ClosableOrder.Click, close, (!isAutoCloseDisabled && isOpen) ?? false);

    useEffect(() => setIsOpen(props.isOpen), [props.isOpen]);

    return (
        <div className={[styles.container, className].join(" ")}>
            {isOpen ? (
                <>
                    <div className={[styles.header, hasNotification ? styles.hasNotification : null].join(" ")} onMouseDown={close}>
                        {icon}
                        {title}
                    </div>
                    <div className={styles.body} onMouseDown={e => !isAutoCloseDisabled && e.stopPropagation()}>
                        {children}
                    </div>
                </>
            ) : (
                <div className={[styles.dropdown, hasNotification ? styles.hasNotification : null].join(" ")} onMouseDown={open}>
                    {icon}
                    <ArrowDropDownIcon fontSize="small" />
                </div>
            )}
        </div>
    );
}

interface IDropdownProps {
    icon: ReactElement;
    title: string;
    children: ReactElement;
    hasNotification?: boolean;
    className?: string;
    isAutoCloseDisabled?: boolean;
    isOpen?: boolean;
    setIsOpen?: (value: boolean) => void;
}

export default observer(Dropdown);